import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { AuthService } from './auth.service';
import { LoadingService } from './loading.service';

@Injectable({
    providedIn: 'root'
})
export class AppService {
    public user: any = null;
    public menu: any = null;

    constructor(
        private router: Router,
        private toastr: ToastrService,
        private authService: AuthService,
        public loadingService: LoadingService,
    ) { }

    async loginByAuth({ username, password }) {
        try {
            const res: any = await this.authService.postLogin({ username, password })
            const { token, tokenRefresh } = res;
            localStorage.setItem('mGJDjUtgSKCdXvBwbjjy', token);
            localStorage.setItem('tVwaiEWPgR6ra0N1gTxSBH0q3EbY0M', tokenRefresh);
            await this.getProfile();
            this.router.navigate(['/']);
            this.toastr.success('Acceso concedido');
        } catch (error) {
            this.toastr.error('El usuario o contraseña no son correctas. Inténtelo nuevamente', 'Error de inicio de sesion')
        }
    }

    /*  async registerByAuth({ email, password }) {
         try {
             const token = await Gatekeeper.registerByAuth(email, password);
             localStorage.setItem('token', token);
             await this.getProfile();
             this.router.navigate(['/']);
             this.toastr.success('Register success');
         } catch (error) {
             this.toastr.error(error.message);
         }
     }
 
     async loginByGoogle() {
         try {
             const token = await Gatekeeper.loginByGoogle();
             localStorage.setItem('token', token);
             await this.getProfile();
             this.router.navigate(['/']);
             this.toastr.success('Login success');
         } catch (error) {
             this.toastr.error(error.message);
         }
     }
 
     async registerByGoogle() {
         try {
             const token = await Gatekeeper.registerByGoogle();
             localStorage.setItem('token', token);
             await this.getProfile();
             this.router.navigate(['/']);
             this.toastr.success('Register success');
         } catch (error) {
             this.toastr.error(error.message);
         }
     }
 
     async loginByFacebook() {
         try {
             const token = await Gatekeeper.loginByFacebook();
             localStorage.setItem('token', token);
             await this.getProfile();
             this.router.navigate(['/']);
             this.toastr.success('Login success');
         } catch (error) {
             this.toastr.error(error.message);
         }
     }
 
     async registerByFacebook() {
         try {
             const token = await Gatekeeper.registerByFacebook();
             localStorage.setItem('token', token);
             await this.getProfile();
             this.router.navigate(['/']);
             this.toastr.success('Register success');
         } catch (error) {
             this.toastr.error(error.message);
         }
     } */

    async getProfile() {
        try {
            let res = await this.authService.getProfile()
            this.user = res.data.user
            this.menu = res.data.menu
        } catch (error) {
            this.logout();
        }
    }

    logout() {
        localStorage.removeItem('mGJDjUtgSKCdXvBwbjjy');
        this.user = null;
        this.router.navigate(['/login']);
    }
}
